<p>
    Use yer jets to knock the enemy down! First to 9 wins! Jet Attack is a
    competitive rag-doll physics game with exploding limbs!
</p>

<p>
    This was built as a spin off of "Don't Fall!". I also built a version with
    integrated leaderboards, achievements, and a single player mode for Y8.com.
</p>
